import React from 'react'
import { UiCol, UiRowContainer, UiSingleContainer, UiSingleRow } from "../../../components/grid-container/GridContainer"
import { UiTopBgSlider, UiTopBgSliderLeftContent, UiInnerTopBgSlider,UiTopBgLearnSlider } from "../../../components/common/UiTopBgSliderElements"
import SliderHeart from "../../../../../styles/img/slider-heart-icon.png";
import UiInnerTopSliderCard from "../../../components/common/UiInnerTopSliderCard"
import { UiSliderImageCard } from '../../../components/common/UiSliderImageCard';
import volvoLogo from '../../../../../styles/img/volvo-logo-round.png';
import bannerPerson from '../../../../../styles/img/knw-banner-pers.png';
import { Button } from 'react-bootstrap';
import { UiSplitImages } from '../../../components/common/UiSplitImages';
import UserImage from '../../../../../styles/img/user.jpg'
import KnowledgeBanner from '../../../../../styles/img/knowledge-home-banner.png'
import KnowledgeHomeImg from '../../../../../styles/img/toyota-knowledge-home-logo.png'

export default function KnowledgeBaner(props) {


    const learnMore = () => {
    }

    const TeamImage = [ UserImage,UserImage ,UserImage,UserImage ];


    return (
        <>
            <UiInnerTopBgSlider>
                <UiTopBgLearnSlider bgImage={KnowledgeBanner}>
                    <UiSingleRow className={props.className}>
                        <UiCol lg="6" className="sb-knowl-main-banner">
                            <UiTopBgSliderLeftContent>
                                <h2>{props.title}</h2>
                                <p className='sb-top-bg-slider__slider-content__description'>{props.description}</p>

                                {props.buttonSet &&
                                    <div className='sb-top-bg-slider__slider-content__slider-bottom-info'>
                                        <h5>EARN WITH THE Q1 PRODUCT QUIZ NOW</h5>
                                        <label>Q1 Quiz</label>
                                    </div>
                                }
                            </ UiTopBgSliderLeftContent>
                        </UiCol>
                        <UiCol lg="6" className="text-end">
                            <img src={KnowledgeHomeImg} />
                        </UiCol>
                        {/* <UiCol lg="7" className="mt-3 sb-knowl-main-banner-img">

                            <div className='sb-knw-img-cont-card-1'>
                                <img src={volvoLogo} />
                                <div>
                                    <h4>Volvo Special</h4>
                                    <p>Multiple Categories</p>
                                </div>
                            </div>

                            <div className='sb-knw-img-cont-card-2'>
                            <img src={bannerPerson} />
                                <div>
                                    <h4>Jamie Vardy</h4>
                                    <p>Helpful Knowledge!</p>
                                </div>
                            </div>
                            <div className='sb-knw-img-cont-card-3'>
                                <UiSplitImages images={TeamImage} lastChild="+ 50"/>
                                <p>50+ friends have completed this</p>
                            </div>
                            <UiSliderImageCard
                                image={props.sliderCardImage}
                                content={props.content}
                                contentTitle={props.contentTitle}
                                contentDedsc={props.contentDedsc}
                                contentTopLeftAlign={props.contentTopLeftAlign}
                            />
                        </UiCol> */}
                    </UiSingleRow>
                </UiTopBgLearnSlider>
            </UiInnerTopBgSlider>
        </>
    )
}
